import React from 'react';
import { css } from 'aphrodite';

import styles from './styles';

const CardBreak = () => <div className={css(styles.cardBreak)} />;

export default CardBreak;
